export default "https://cdn-static.gokick.com/assets/c66ec253f0896645bf734992981ccce4219a90e3/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";